module.exports = "/images/vendor/flag-icon-css/flags/1x1/bv.svg?b70ab2f2a1fdb7d66f6870a4f243f843";